module.exports = __webpack_public_path__ + "static/media/schools_chiffre_bg.30967f04.png";